module.exports = {
   components: [],
   routes: [{
         name: "BuyVoucher",
         path: "/",
         component: () => import('./main/voucher.vue'),
      },
      {
         name: "DownloadVoucher",
         path: "/voucher/:voucher_code",
         component: () => import('./download/download-voucher.vue'),
      },
   ],
   sub_routes: [
   ]
}